<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="渠道" class="fn-left">
            <Select key="5" :selected.sync="listQuery.channel_id" :data="channelLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="手机" class="fn-left">
            <el-input v-model="listQuery.mobile" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item label="学员姓名" class="fn-left">
            <el-input v-model="listQuery.sub_name" placeholder="请输入学员姓名" />
          </el-form-item>
          <!-- <el-form-item label="时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item> -->
          <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnGetStudentLists()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="学员" prop="sub_name" align="center" />
        <el-table-column label="手机" prop="mobile" align="center" />
        <el-table-column label="渠道" prop="channel_name" align="center" />
        <el-table-column label="创建人" prop="editor_name" align="center" />
        <el-table-column label="创建时间" prop="create_time" align="center" />
        <el-table-column label="图片" align="center">
          <template slot-scope="{row}">
            <el-image v-if="row.extra.referral_images" style="width: 40px; height: 40px" :src="row.extra.referral_images" :preview-src-list="[row.extra.referral_images]" fit="fit" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetStudentLists" />
    </div>
  </div>

</template>
<script>

import Select from '@/components/Select'

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TurnStudentList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20,
        channel_id: '',
        mobile: '',
        tll_status: '',
        sub_name: ''
      },
      channelLists: [{
        id: '101',
        name: '班主任推荐'
      }, {
        id: '106',
        name: '天天陪读'
      }, {
        id: '107',
        name: '小学生'
      },
      {
        id: '10',
        name: '后端创建'
      },
      {
        id: '9',
        name: '小学生自主创建'
      }]

    }
  },
  created() {
    this.fnGetStudentLists()
  },
  methods: {
    fnGetStudentLists: function() {
      this.$http.turnStudentList(this.listQuery).then(res => {
        this.lists = res.data.list
        this.total = parseInt(res.data.count)
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
